import { Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { useEffect } from 'react';
import Icon from '@mui/material/Icon';
import LinearProgress from '@mui/material/LinearProgress';
import { useSelector } from 'react-redux';
import { Topnav } from 'components/Topnav';
import { SidenavLayout } from 'components/LayoutContainers/SidenavLayout';
import { useMaterialUIController } from 'context';
import useConf from 'hook/useConf';
import { useGetConfigurationQuery } from 'services/applicationApi';
import IdleContainer from 'components/Security/IdleContainer';
import ScrollTop from 'components/Scroll/ScrollTop';
import ErrorFallback from 'pages/template/ErrorFallback';

export function SidenavTemplate({ navigationRoutes, menuRoutes }) {
  const appState = useSelector((state) => state.app);
  const { setPageTitle } = useMaterialUIController();

  const theme = useTheme();
  const { palette } = theme;
  const { background } = palette;

  const location = useLocation();
  useEffect(() => {
    setPageTitle(null);
  }, [location.key, setPageTitle]);

  const { getValue: conf } = useConf(useGetConfigurationQuery);

  return (
    <IdleContainer
      timeout={conf('security.session.timeout')}
      promptTimeout={conf('security.session.promptTimeout')}
    >
      <SidenavLayout layout="dashboard" routes={menuRoutes}>
        {Array.isArray(navigationRoutes) && navigationRoutes.length > 0 && (
          <Topnav routes={navigationRoutes} />
        )}
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Outlet />
        </ErrorBoundary>

        <ScrollTop>
          <Icon fontSize="large" color="inherit">
            keyboard_double_arrow_up
          </Icon>
        </ScrollTop>

        {appState.appLoading && (
          <Box
            position="fixed"
            top={0}
            left={0}
            pb={1}
            sx={{
              width: '100%',
              backgroundColor: background.default
            }}
          >
            <LinearProgress sx={{ borderRadius: 'unset' }} />
          </Box>
        )}
      </SidenavLayout>
    </IdleContainer>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.object.isRequired,
  resetErrorBoundary: PropTypes.func
};

SidenavTemplate.propTypes = {
  navigationRoutes: PropTypes.any,
  menuRoutes: PropTypes.any
};
